import React, { useEffect, useState } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { apiService } from "../../../api/apiService";
import GPAdminFileViewPopup from "../Popup/GPAdminFileViewPopup";
import GlobalPoliciesFileViewPopup from "../Popup/GlobalPoliciesFileViewPopup";
import { Box, CircularProgress } from "@mui/material";

interface ExistingBdCsvPopupProps {
  open: boolean;
  onClose: () => void;
  fileId: string | null;
  isAdmin?: boolean;
  isManager?: boolean;
  closePopup?: () => void;
  onSuccess?: () => void;
}

const ExsitingBdCsvPopup: React.FC<ExistingBdCsvPopupProps> = ({
  open,
  onSuccess,
  fileId,
  closePopup,
}) => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const userRole = localStorage.getItem("role");
  const isManager = userRole === "manager";
  const isAdmin = userRole === "admin" || userRole === "super_admin";

  const [imagePreview, setImagePreview] = useState<any | null>(null);

   const notifyLoadingComplete = () => {
    if (closePopup) {
      // Signal to parent that popup content is loaded
      const event = new CustomEvent('popup-loaded');
      window.dispatchEvent(event);
    }
  };

  useEffect(() => {
    const fetchFileDetails = async () => {
      if (!fileId || !open) return;

      setLoading(true);
      setError(null);

      try {
        const downloadResult = await apiService(
          `/management/existing_business_desc/${fileId}`,
          "GET",
          undefined,
          undefined,
          instance as PublicClientApplication
        );
        setImagePreview(downloadResult.data);
      } catch (error) {
        console.error("Error fetching job hierarchy:", error);
        setError("Failed to load file.");
      } finally {
        setLoading(false);
        notifyLoadingComplete();
      }
    };

    fetchFileDetails();
  }, [fileId, open, instance]);

  console.log("check for data ", imagePreview);
  console.log("Rendering conditions:", {
    loading,
    hasImagePreview: !!imagePreview,
  });

  console.log('check user role', isManager, isAdmin);

  return (
    <>
       {loading && open && (
        <Box 
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            borderRadius: '8px'
          }}
        >
          <CircularProgress />
          <Box sx={{ mt: 2 }}>Loading file...</Box>
        </Box>
      )}
    
      {!loading && imagePreview && (
        <>
          {isManager && (
            <GlobalPoliciesFileViewPopup
              onClose={closePopup || (() => {})}
              open={open}
              name={imagePreview.file_name}
              id={imagePreview.id}
              functionl1={imagePreview.function_l1}
              date={imagePreview.updated_at}
              updatedBy={imagePreview.updated_by}
              sectionTitle="Business Description"
              userDetail={true}
              apiPath={`/management/existing_business_desc/${imagePreview.id}`}
            />
          )}

          {isAdmin && (
            <GPAdminFileViewPopup
              onClose={closePopup || (() => {})}
              open={open}
              name={imagePreview.file_name}
              id={imagePreview.id}
              functionl1={imagePreview.function_l1}
              date={imagePreview.updated_at}
              updatedBy={imagePreview.updated_by}
              status={imagePreview.status}
              reason_to_approve={imagePreview.reason_to_approve}
              reason_to_revert={imagePreview.reason_to_revert}
              sectionTitle="Business Description"
              apiPath={`/management/existing_business_desc/${imagePreview.id}`}
              statusApiPath="/management/existing_business_desc_status"
              onSuccess={onSuccess}
            />
          )}
        </>
      )}
    </>
  );
};

export default ExsitingBdCsvPopup;